import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import tableSelector from 'selectors/indicator/table';

// Components
import table from 'components/table';

// Styles
import styles from './mapViewTable.scss';

const Table = table();

const MapViewTable = (props) => (
  <section className={styles.mapViewTable}>
    <Table {...props} />
  </section>
);

MapViewTable.defaultProps = {
  isTwoCol: false,
};

MapViewTable.propTypes = {
  isTwoCol: PropTypes.bool,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      idx: PropTypes.number.isRequired,
      colId: PropTypes.string.isRequired,
      label: PropTypes.string,
      fixed: PropTypes.oneOf(['left', 'right']),
    })
  ).isRequired,
  rowData: PropTypes.arrayOf(
    PropTypes.shape({
      rowId: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          idx: PropTypes.number.isRequired,
          fixed: PropTypes.oneOf(['left', 'right']),
          align: PropTypes.oneOf(['right', 'center', 'left']),
          formattedValue: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  /* Proptypes below are used in selectors */
  /* eslint-disable react/no-unused-prop-types */
  timeframes: PropTypes.oneOfType([ // selector expects plural timeframes
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  /* eslint-enable */
};

const makeMapStateToProps = (state, ownProps) => tableSelector(state, {
  ...ownProps,
  pinValue: ('usdata' === state.data.indicator.dataView) ?
    'United States' :
    'World',
});

export default connect(makeMapStateToProps)(MapViewTable);



// WEBPACK FOOTER //
// ./app/components/mapViewTable/index.js